/* @flow */
import * as React from 'react';
import { Polygon } from 'common/components/core/map/Polygon';

import type { RouteRestriction } from 'common/models/internal/RouteRestriction';

type Props = {
    isActive: boolean,
    routeRestriction: RouteRestriction,
    mapHelper: {
        map: ?any,
        maps: ?any
    },
    color: string,
    onClick?: (key: string, event: any, props: any) => void
};

class RouteRestrictionPolygon extends React.PureComponent<Props, void> {
    onMouseDown = (id: string, event: any, props: any) => {
        const { onClick } = this.props;
        onClick && onClick(id, event, props);
    };

    getLatLngs(
        routeRestriction: RouteRestriction
    ): Array<{ lat: number, lng: number }> {
        const latLngs = [];
        routeRestriction.polygon.polygons.forEach(polygon => {
            polygon.vertices.forEach(latLng => {
                latLngs.push({
                    lat: latLng.lat,
                    lng: latLng.lng
                });
            });
        });
        return latLngs;
    }

    render() {
        var { routeRestriction, mapHelper, color, isActive } = this.props;
        var latLngs = this.getLatLngs(routeRestriction);
        const fillOpacity = isActive ? 0.5 : 0;
        const strokeWeight = isActive ? 1 : 0;
        return (
            <Polygon
                latLngs={latLngs}
                fillOpacity={fillOpacity}
                strokeWeight={strokeWeight}
                id={routeRestriction.id}
                mapHelper={mapHelper}
                strokeColor={color}
                fillColor={color}
                onMouseDownOnPolygon={this.onMouseDown}
            />
        );
    }
}

export default RouteRestrictionPolygon;
